module.exports = __webpack_public_path__ + "media/images/review/sample-photo-8b6244a95c4e6a4b0cec891689e0f87d.jpg";